// src/mocs/handlers/dashboard/requestFunds_availableFunds.ts

import { rest } from 'msw';
import availableFunds from '@/mocks/data/dashboard_availableFunds.json';
import { API_ENDPOINTS } from '@/services/api/endpoints';
import { VITE_MSW_BASE_URL } from '@/config';
import { IAvailableFunds } from '@/domains/dashboard/requestFunding/requestFunding.types.ts';
import { addDays, format, subDays } from 'date-fns';
import { isAccessTokenExpired } from '@/mocks/lib/authTokenUtils';

export const requestFundsAvailableFundsHandler = rest.get<IAvailableFunds>(
  `${VITE_MSW_BASE_URL}${API_ENDPOINTS.DASHBOARD_AVAILABLE_FUNDS}`,
  (req, res, ctx) => {
    const token = req.headers.get('Authorization');
    if (!token) {
      return res(ctx.status(500), ctx.json({ detail: 'Something went wrong' }));
    }

    if (isAccessTokenExpired()) {
      return res(ctx.status(401), ctx.json({ error: 'Access token expired' }));
    }

    const { customer_uuid } = req.params as { customer_uuid: string };
    const today = new Date();
    const updated_at = `${format(subDays(today, 5), 'yyyy-MM-dd')}T08:03:10`;
    const start_from = format(addDays(today, 5), 'yyyy-MM-dd');
    const match = availableFunds.find((entry) => entry.uuid === customer_uuid);

    const mockResponse: IAvailableFunds = {
      aggregated_funds: {
        amount: match ? match.availableFunds.amount : 0,
        currency: match ? match.availableFunds.currency : 'GBP',
      },
      min_funding_amount: match ? match.min_funding_amount : 1000,
      updated_at: updated_at,
      start_from: start_from,
    };

    // Return the mock response
    return res(ctx.status(200), ctx.json(mockResponse));
  },
);
